module.exports = __webpack_public_path__ + "img/bottomright.96b0c858.png";